export default __webpack_public_path__ + "static/media/apache.bde634d2.png";